/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ulrich_Von_Hutten_Gymnasium3Inputs */

const en__field_enum_ulrich_von_hutten_gymnasium3 = /** @type {(inputs: _Field_Enum_Ulrich_Von_Hutten_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüchtern`)
};

const de__field_enum_ulrich_von_hutten_gymnasium3 = /** @type {(inputs: _Field_Enum_Ulrich_Von_Hutten_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulrich-von-Hutten-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Schlüchtern" |
*
* @param {_Field_Enum_Ulrich_Von_Hutten_Gymnasium3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ulrich_von_hutten_gymnasium3 = /** @type {((inputs?: _Field_Enum_Ulrich_Von_Hutten_Gymnasium3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ulrich_Von_Hutten_Gymnasium3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ulrich_von_hutten_gymnasium3(inputs)
	return de__field_enum_ulrich_von_hutten_gymnasium3(inputs)
});
export { _field_enum_ulrich_von_hutten_gymnasium3 as "_field_enum_Ulrich_von_Hutten_Gymnasium" }